export * from './esports-slide.model';
export * from './esports-slide.service';
export * from './esports-slide-form.service';


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/esports-slides/shared/index.ts